export default (theme) => ({
  secondaryText: {
    fontSize: theme.typography.h5.fontSize,
    fontWeight: theme.typography.fontWeightBold,
    marginBottom: theme.spacing(4),
  },
  results: {
  },
  resultItem: {
    marginBottom: theme.spacing(2),
    backgroundColor: theme.palette.facet.lightGray,
    '&:hover': {
      backgroundColor: theme.palette.facet.lightGray,
    },
  },
});
